export default {
    en: {
        id: 'diagram4c2-2',
        blocks: [
            {
                task: 'S = Bank planning to move Data Center to NY',
                title: "S = ",
                answer: 'Planning to do X ',
                modelName: 's'
            },
            {
                task: 'C = Move predicated on three assumptions',
                title: "C = ",
                answer: 'Based on belief in Y ',
                modelName: 'c'
            },
            {
                task: 'Q = (Are these assumptions correct?)',
                title: "Q = Is belief in Y sound?",
                answer: ' ',
                disableEdit: true
            }
        ],
        title: 'Type in roughly what the Situation and Complication should say'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c2/practiceInSeeing3/i18n/exercise2.js